<script setup lang="ts">
import { AppMessageBox } from '@libs/ui';

import type { PeekPriceModalMultiIngredientItinerary } from '../../models';
import {
  isMultiIngredientAccommodationCard,
  isMultiIngredientBookableTransportCard,
  isMultiIngredientNonBookableTransportCard,
} from '../../models';

import PeekPriceNonBookableTransportCard from './PeekPriceNonBookableTransportCard.vue';
import PeekPriceSmallHotelCard from './PeekPriceSmallHotelCard.vue';
import PeekPriceBookableTransportCard from './PeekPriceBookableTransportCard.vue';

interface PeekPriceMultiIngredientProps {
  itinerary: PeekPriceModalMultiIngredientItinerary;
}

const props = defineProps<PeekPriceMultiIngredientProps>();
</script>

<template>
  <div class="peek-price-multi-itinerary">
    <AppMessageBox
      :text="props.itinerary.peekPriceAccommodationSummary"
      message-type="brand-lagoon"
      class="message-box"
    />

    <template v-for="(card, index) of props.itinerary.cards" :key="index">
      <PeekPriceNonBookableTransportCard
        v-if="isMultiIngredientNonBookableTransportCard(card)"
        :data="card.data"
      />
      <PeekPriceBookableTransportCard
        v-if="isMultiIngredientBookableTransportCard(card)"
        :data="card.data"
        logo-size="large"
      />
      <PeekPriceSmallHotelCard
        v-if="isMultiIngredientAccommodationCard(card)"
        :data="card.data"
      />
      <div
        v-if="index !== props.itinerary.cards.length - 1"
        class="separator"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.peek-price-multi-itinerary {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);

  .separator {
    border-bottom: 1px solid var(--color-neutral-20);
  }
}
</style>
